import { Dropdown } from "primereact/dropdown";
import React, { FunctionComponentElement } from "react";
import { NodeInputProps } from "./index";
import { useGetEdsListQuery } from "../../pages/libraries/EdsApiSlice";
import "./Form.module.scss";
import { classNames } from 'primereact/utils';
import {  useAppSelector } from "../../hooks/hooks";

export const EdsChoiceInput = (props: NodeInputProps): FunctionComponentElement<NodeInputProps> => {

    const environment = useAppSelector((state) => state.editor.current?.environnement)
    const {data: edsList, isError} = useGetEdsListQuery({edsType: props.typeParam || '', env:environment ? environment : ""}, {skip: !props.typeParam});

    if (!props || !props.typeParam) {
        return <span>Mauvaise configuration du champ</span>
    }
    return <>
        <Dropdown
            className={classNames({'p-invalid': isError})}
            disabled={isError || props.disabled}
            filter
            emptyFilterMessage="Aucun EDS correspondant"
            value={edsList?.find((element) => element.name === props.value?.name && element.type === props.value?.type)}
            options={edsList}
            optionLabel="displayName"
            onChange={(element) => {
                props.onChange(element.value)
            }}
            placeholder={props.placeholder}
        />
        {isError && <span style={{color: 'red'}}>Erreur lors de l'appel à l'API EDS </span>}
    </>
}